var map = {
	"./sucht_A1.png": 15796,
	"./sucht_A2.png": 5161,
	"./sucht_B1.png": 9648,
	"./sucht_B2.png": 78655,
	"./sucht_C1.png": 45163,
	"./sucht_C2.png": 43623,
	"./sucht_D1.png": 78888,
	"./sucht_D2.png": 45064,
	"./sucht_E1.png": 10279,
	"./sucht_E2.png": 26692,
	"./sucht_F1.png": 63163,
	"./sucht_F2.png": 10508,
	"./sucht_G1.png": 79773,
	"./sucht_G2.png": 66799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72034;